/* Mint Root v3 — interacciones propias (sin librerías) */
(function () {
  'use strict';

  document.documentElement.classList.add('mr-js');

  var sinMovimiento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function todos(sel, raiz) {
    return Array.prototype.slice.call((raiz || document).querySelectorAll(sel));
  }

  /* Aparición suave al hacer scroll (también dibuja la línea de tiempo) */
  function initReveal() {
    var els = todos('.mr-reveal:not(.mr-visible)');
    if (!els.length) return;
    if (sinMovimiento || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('mr-visible');
      });
      return;
    }
    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('mr-visible');
          obs.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    els.forEach(function (el) {
      obs.observe(el);
    });
  }

  /* Carriles deslizables: puntos y contador (1/10) */
  function initCarril(carril) {
    if (!carril || carril.dataset.mrListo) return;
    carril.dataset.mrListo = '1';
    var raiz = carril.closest('[data-mr-carrusel]') || carril.parentElement;
    var items = Array.prototype.slice.call(carril.children);
    var puntos = todos('[data-mr-punto]', raiz);
    var actual = raiz.querySelector('[data-mr-actual]');
    if (items.length < 2) return;

    function activo() {
      if (carril.scrollLeft <= 2) return 0;
      if (carril.scrollLeft + carril.clientWidth >= carril.scrollWidth - 2) return items.length - 1;
      var ref = carril.getBoundingClientRect().left + carril.clientWidth / 2;
      var mejor = 0;
      var distancia = Infinity;
      items.forEach(function (it, i) {
        var r = it.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - ref);
        if (d < distancia) {
          distancia = d;
          mejor = i;
        }
      });
      return mejor;
    }

    function pintar() {
      var i = activo();
      puntos.forEach(function (p, n) {
        p.setAttribute('data-activo', String(n === i));
      });
      if (actual) actual.textContent = String(i + 1);
    }

    var pendiente = false;
    carril.addEventListener(
      'scroll',
      function () {
        if (pendiente) return;
        pendiente = true;
        window.setTimeout(function () {
          pendiente = false;
          pintar();
        }, 70);
      },
      { passive: true }
    );
    if ('onscrollend' in window) carril.addEventListener('scrollend', pintar);
    pintar();
  }

  /* Ampliar foto al tocar */
  function initLupa() {
    var lupa = document.querySelector('[data-mr-lupa]');
    var galeria = document.querySelector('[data-mr-galeria]');
    if (!lupa || !galeria || lupa.dataset.mrListo || typeof lupa.showModal !== 'function') return;
    lupa.dataset.mrListo = '1';
    var fotos = todos('[data-mr-ampliar]', galeria);
    var img = lupa.querySelector('[data-mr-lupa-img]');
    var pie = lupa.querySelector('[data-mr-lupa-pie]');
    var cuenta = lupa.querySelector('[data-mr-lupa-cuenta]');
    var i = 0;

    function mostrar(n) {
      i = (n + fotos.length) % fotos.length;
      var f = fotos[i];
      img.src = f.dataset.grande;
      img.alt = f.dataset.alt || '';
      pie.textContent = f.dataset.pie || '';
      cuenta.textContent = i + 1 + '/' + fotos.length;
    }

    fotos.forEach(function (f, n) {
      f.addEventListener('click', function () {
        mostrar(n);
        lupa.showModal();
      });
    });
    todos('[data-mr-lupa-cerrar]', lupa).forEach(function (b) {
      b.addEventListener('click', function () {
        lupa.close();
      });
    });
    var atras = lupa.querySelector('[data-mr-lupa-atras]');
    var sigue = lupa.querySelector('[data-mr-lupa-sigue]');
    if (atras) atras.addEventListener('click', function () { mostrar(i - 1); });
    if (sigue) sigue.addEventListener('click', function () { mostrar(i + 1); });
    lupa.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowLeft') mostrar(i - 1);
      if (ev.key === 'ArrowRight') mostrar(i + 1);
    });
  }

  /* Variantes: si el producto tiene varias, el desplegable actualiza el precio */
  function initVariantes() {
    todos('[data-mr-producto]').forEach(function (raiz) {
      var select = raiz.querySelector('[data-mr-variante]');
      if (!select || select.dataset.mrListo) return;
      select.dataset.mrListo = '1';
      select.addEventListener('change', function () {
        var op = select.options[select.selectedIndex];
        todos('[data-mr-precio]', raiz).forEach(function (el) {
          el.textContent = op.dataset.precio;
        });
        todos('[data-mr-comprar]', raiz).forEach(function (btn) {
          var disponible = op.dataset.disponible === 'true';
          btn.disabled = !disponible;
          var texto = btn.querySelector('[data-mr-texto]') || btn;
          texto.textContent = disponible ? btn.dataset.textoComprar : btn.dataset.textoAgotado;
        });
      });
    });
  }

  /* Barra fija en móvil: aparece cuando el botón principal sale de la pantalla y se esconde al llegar al cierre */
  function initBarra() {
    var barra = document.querySelector('[data-mr-barra]');
    if (!barra || barra.dataset.mrListo) return;
    var boton = document.querySelector('[data-mr-boton-principal]');
    if (!boton || !('IntersectionObserver' in window)) return;
    barra.dataset.mrListo = '1';
    document.body.classList.add('mr-con-barra');
    var pasado = false;
    var enCierre = false;

    function pintar() {
      var ver = pasado && !enCierre;
      barra.classList.toggle('mr-visible', ver);
      barra.setAttribute('aria-hidden', String(!ver));
      if (ver) barra.removeAttribute('inert');
      else barra.setAttribute('inert', '');
    }

    /* La barra sale siempre que el botón principal no esté a la vista (también si queda más abajo en pantallas pequeñas) */
    new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        pasado = !e.isIntersecting;
      });
      pintar();
    }).observe(boton);

    /* Se mide al desplazarse (y no solo al cruzar el cierre) para que también funcione si se salta de golpe al final */
    var cierre = document.querySelector('[data-mr-cierre]');
    if (cierre) {
      var medirCierre = function () {
        var r = cierre.getBoundingClientRect();
        var antes = enCierre;
        enCierre = r.top < window.innerHeight - Math.min(r.height, window.innerHeight) * 0.25;
        if (enCierre !== antes) pintar();
      };
      var esperando = false;
      var alMover = function () {
        if (esperando) return;
        esperando = true;
        window.setTimeout(function () {
          esperando = false;
          medirCierre();
        }, 100);
      };
      window.addEventListener('scroll', alMover, { passive: true });
      window.addEventListener('resize', alMover);
      medirCierre();
    }
    pintar();
  }

  /* Formulario de opinión: si falta algo, se avisa en el propio campo. Los avisos del navegador apenas se ven en el
     móvil (el de las estrellas salía sobre un punto invisible) y parecía que el botón no hacía nada.
     El envío sigue siendo el normal del formulario de contacto de Shopify: aquí no se intercepta ni se simula.
     OJO: se comprueba al pulsar el botón y no en el «submit», porque la protección contra robots de Shopify
     escucha el «submit» y envía el formulario por su cuenta aunque otro código lo haya cancelado. */
  function initOpinion() {
    todos('.mr-opin__form').forEach(function (form) {
      if (form.dataset.mrListo) return;
      var boton = form.querySelector('button[type="submit"]');
      if (!boton) return;
      form.dataset.mrListo = '1';
      var textoBoton = boton.querySelector('[data-mr-texto]');
      var textoNormal = textoBoton ? textoBoton.textContent : '';
      var avisoFallo = form.querySelector('[data-mr-fallo]');
      var enviando = false;
      var espera = 0;

      function soltar() {
        enviando = false;
        window.clearTimeout(espera);
        boton.removeAttribute('aria-busy');
        if (textoBoton) textoBoton.textContent = textoNormal;
      }

      function fallo(caja) {
        var texto = caja.dataset.error || '';
        if (caja.hasAttribute('data-mr-estrellas')) return caja.querySelector('input:checked') ? '' : texto;
        var control = caja.querySelector('input, textarea');
        if (!control) return '';
        if (!control.value.trim()) return texto;
        if (control.type === 'email' && !control.checkValidity()) return texto;
        return '';
      }

      function pintar(caja, texto) {
        var aviso = caja.querySelector('[data-mr-error]');
        var control = caja.querySelector('input, textarea');
        if (texto) caja.setAttribute('data-mal', '');
        else caja.removeAttribute('data-mal');
        if (aviso) {
          aviso.textContent = texto;
          aviso.hidden = !texto;
        }
        if (control) {
          if (texto) control.setAttribute('aria-invalid', 'true');
          else control.removeAttribute('aria-invalid');
        }
      }

      todos('[data-mr-campo]', form).forEach(function (caja) {
        function repasar() {
          if (caja.hasAttribute('data-mal')) pintar(caja, fallo(caja));
        }
        caja.addEventListener('input', repasar);
        caja.addEventListener('change', repasar);
      });

      /* Pulsar Intro dentro de un campo también pasa por aquí: el navegador lo convierte en un clic del botón */
      boton.addEventListener('click', function (ev) {
        if (enviando) {
          ev.preventDefault();
          return;
        }
        var primero = null;
        todos('[data-mr-campo]', form).forEach(function (caja) {
          var texto = fallo(caja);
          pintar(caja, texto);
          if (texto && !primero) primero = caja;
        });
        if (primero) {
          ev.preventDefault();
          var control = primero.querySelector('input, textarea');
          if (control) control.focus({ preventScroll: true });
          primero.scrollIntoView({ behavior: sinMovimiento ? 'auto' : 'smooth', block: 'center' });
        }
      });

      /* Solo llega aquí si todo está bien. La comprobación de Shopify tarda unos segundos en llevarse el formulario:
         mientras tanto el botón lo dice, para que no parezca que no pasa nada. Si a los 20 s seguimos en la página,
         se avisa de que no se ha podido enviar y el botón vuelve a funcionar. */
      form.addEventListener('submit', function () {
        enviando = true;
        if (avisoFallo) avisoFallo.hidden = true;
        boton.setAttribute('aria-busy', 'true');
        if (textoBoton && boton.dataset.enviando) textoBoton.textContent = boton.dataset.enviando;
        window.clearTimeout(espera);
        espera = window.setTimeout(function () {
          soltar();
          if (avisoFallo) {
            avisoFallo.hidden = false;
            avisoFallo.scrollIntoView({ behavior: sinMovimiento ? 'auto' : 'smooth', block: 'center' });
          }
        }, 20000);
      });

      /* Si se vuelve atrás desde la comprobación de Shopify, el botón tiene que volver a funcionar */
      window.addEventListener('pageshow', soltar);
    });
  }

  /* Fila de opiniones con efecto túnel: se mueve sola de derecha a izquierda y, según lo lejos que esté cada tarjeta
     del centro, se encoge, gira, se difumina y se apaga. Así parece que sale de un túnel por la derecha y entra en
     otro por la izquierda. Va con requestAnimationFrame y solo cambia transform, opacity y filter (no recoloca nada).
     Las posiciones se miden una vez (y al cambiar el tamaño); en cada fotograma solo hay cuentas.
     La fila lleva dos grupos idénticos: al recorrer uno entero se vuelve al principio y no se nota el salto. */
  function initTunel(sec, cinta) {
    var pista = cinta.querySelector('.mr-res__pista');
    var grupos = pista ? todos('.mr-res__grupo', pista) : [];
    if (grupos.length < 2 || !window.requestAnimationFrame) return;
    var tarjetas = todos('.mr-res__tarjeta', pista);
    var reducido = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var segundos = parseFloat(cinta.dataset.duracion) || 50;
    var fuerza = Math.max(0, Math.min(1, (parseFloat(cinta.dataset.tunel) || 0) / 100));
    var centros = [];
    var ancho = 0;
    var vuelta = 0;
    var tira = 0;
    var pantalla = 0;
    var x = 0;
    var antes = 0;
    var raf = 0;
    var aLaVista = true;
    var activo = false;
    var empezado = false;

    function medir() {
      pantalla = cinta.clientWidth;
      vuelta = grupos[1].offsetLeft - grupos[0].offsetLeft;
      var originales = grupos[0].querySelectorAll('.mr-res__tarjeta:not(.mr-res__extra)').length || 1;
      tira = (vuelta * originales) / (grupos[0].children.length || 1);
      ancho = tarjetas[0].offsetWidth;
      centros = tarjetas.map(function (t) {
        return t.offsetLeft + t.offsetWidth / 2;
      });
    }

    function limpiar(el) {
      el.style.transform = '';
      el.style.opacity = '';
      el.style.filter = '';
      el.style.zIndex = '';
      el.style.visibility = '';
      el.mrT = -1;
      el.mrFuera = false;
    }

    function pintar() {
      pista.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      var medio = pantalla / 2;
      var inicio = ancho * 0.5;
      var fin = medio + ancho * 0.6;
      for (var i = 0; i < tarjetas.length; i++) {
        var el = tarjetas[i];
        var d = centros[i] + x - medio;
        var lejos = Math.abs(d);
        if (lejos > medio + ancho) {
          if (!el.mrFuera) {
            el.style.visibility = 'hidden';
            el.mrFuera = true;
          }
          continue;
        }
        if (el.mrFuera) {
          el.style.visibility = '';
          el.mrFuera = false;
        }
        var t = lejos <= inicio ? 0 : Math.min(1, (lejos - inicio) / (fin - inicio));
        if (t === 0 || fuerza === 0) {
          if (el.mrT !== 0) {
            el.style.transform = '';
            el.style.opacity = '';
            el.style.filter = '';
            el.style.zIndex = '100';
            el.mrT = 0;
          }
          continue;
        }
        var lado = d > 0 ? 1 : -1;
        var escala = 1 - t * 0.42 * fuerza;
        var giro = lado * t * 62 * fuerza;
        var haciaDentro = -lado * t * ancho * 0.55 * fuerza;
        var opacidad = 1 - Math.pow(t, 1.4) * (0.45 + 0.55 * fuerza);
        var niebla = t * t * 6 * fuerza;
        el.style.transform = 'perspective(900px) translate3d(' + haciaDentro.toFixed(1) + 'px,0,0) rotateY(' + giro.toFixed(1) + 'deg) scale(' + escala.toFixed(3) + ')';
        el.style.opacity = opacidad.toFixed(3);
        el.style.filter = niebla > 0.4 ? 'blur(' + niebla.toFixed(1) + 'px)' : '';
        el.style.zIndex = String(100 - Math.round(t * 90));
        el.mrT = t;
      }
    }

    /* También se para si alguien navega con el teclado por dentro de la fila */
    function conTeclado() {
      try {
        return !!cinta.querySelector(':focus-visible');
      } catch (e) {
        return false;
      }
    }

    function parada() {
      return (
        sec.hasAttribute('data-pausa') ||
        sec.hasAttribute('data-tocando') ||
        sec.hasAttribute('data-raton') ||
        sec.hasAttribute('data-ventana') ||
        conTeclado()
      );
    }

    function paso(ahora) {
      raf = 0;
      if (!activo) return;
      var dt = antes ? Math.min(64, ahora - antes) : 16;
      antes = ahora;
      if (!parada()) {
        x -= (tira / segundos) * (dt / 1000);
        if (x <= -vuelta) x += vuelta;
        pintar();
      }
      if (aLaVista && !document.hidden) raf = window.requestAnimationFrame(paso);
    }

    function arrancar() {
      if (!activo || raf || !aLaVista || document.hidden) return;
      antes = 0;
      raf = window.requestAnimationFrame(paso);
    }

    function encender() {
      if (reducido && reducido.matches) {
        activo = false;
        sec.removeAttribute('data-mr-res-tunel');
        pista.style.transform = '';
        tarjetas.forEach(limpiar);
        return;
      }
      activo = true;
      sec.setAttribute('data-mr-res-tunel', '');
      medir();
      /* Se empieza con una tarjeta justo en el centro y la pantalla ya llena a su izquierda */
      if (!empezado) {
        empezado = true;
        for (var k = 0; k < centros.length; k++) {
          if (centros[k] >= pantalla) {
            x = pantalla / 2 - centros[k];
            break;
          }
        }
      }
      pintar();
      arrancar();
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (e) {
            aLaVista = e.isIntersecting;
          });
          arrancar();
        },
        { rootMargin: '200px 0px' }
      ).observe(cinta);
    }
    document.addEventListener('visibilitychange', arrancar);
    var espera = 0;
    window.addEventListener('resize', function () {
      window.clearTimeout(espera);
      espera = window.setTimeout(function () {
        if (!activo) return;
        medir();
        if (x <= -vuelta) x = 0;
        pintar();
      }, 150);
    });
    if (reducido) {
      if (reducido.addEventListener) reducido.addEventListener('change', encender);
      else if (reducido.addListener) reducido.addListener(encender);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (activo) {
          medir();
          pintar();
        }
      });
    }
    encender();
  }

  /* Cinta de opiniones: el botón de pausa, parar al tocar o con el ratón, y «Leer más» (solo en las opiniones
     que no caben) con su ventana. El movimiento lo lleva initTunel. */
  function initResenas() {
    todos('[data-mr-res]').forEach(function (sec) {
      if (sec.dataset.mrListo) return;
      sec.dataset.mrListo = '1';

      function medir() {
        todos('[data-mr-res-texto]', sec).forEach(function (texto) {
          var mas = texto.parentElement.querySelector('[data-mr-res-mas]');
          if (!mas || texto.closest('dialog')) return;
          mas.hidden = texto.scrollHeight <= texto.clientHeight + 2;
        });
      }
      medir();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(medir);
      var pendiente = 0;
      window.addEventListener('resize', function () {
        window.clearTimeout(pendiente);
        pendiente = window.setTimeout(medir, 200);
      });

      var pausa = sec.querySelector('[data-mr-res-pausa]');
      if (pausa) {
        pausa.addEventListener('click', function () {
          var parada = !sec.hasAttribute('data-pausa');
          if (parada) sec.setAttribute('data-pausa', '');
          else sec.removeAttribute('data-pausa');
          pausa.setAttribute('aria-pressed', String(parada));
          var texto = pausa.querySelector('[data-mr-texto]');
          if (texto) texto.textContent = parada ? pausa.dataset.reanudar : pausa.dataset.pausar;
        });
      }

      var cinta = sec.querySelector('[data-mr-res-cinta]');
      if (cinta) {
        var soltar = 0;
        cinta.addEventListener(
          'touchstart',
          function () {
            window.clearTimeout(soltar);
            sec.setAttribute('data-tocando', '');
          },
          { passive: true }
        );
        var alSoltar = function () {
          window.clearTimeout(soltar);
          soltar = window.setTimeout(function () {
            sec.removeAttribute('data-tocando');
          }, 1500);
        };
        cinta.addEventListener('touchend', alSoltar, { passive: true });
        cinta.addEventListener('touchcancel', alSoltar, { passive: true });
        /* Solo con ratón de verdad: en el móvil un toque también dispara «mouseenter» y se quedaría parada */
        cinta.addEventListener('pointerenter', function (ev) {
          if (ev.pointerType === 'mouse') sec.setAttribute('data-raton', '');
        });
        cinta.addEventListener('pointerleave', function () {
          sec.removeAttribute('data-raton');
        });
        initTunel(sec, cinta);
      }

      var ventana = sec.querySelector('[data-mr-res-ventana]');
      if (!ventana || typeof ventana.showModal !== 'function') return;
      var contenido = ventana.querySelector('[data-mr-res-contenido]');
      sec.addEventListener('click', function (ev) {
        var mas = ev.target.closest && ev.target.closest('[data-mr-res-mas]');
        if (!mas) return;
        var copia = mas.closest('.mr-res__tarjeta').cloneNode(true);
        copia.classList.remove('mr-res__extra');
        copia.removeAttribute('aria-hidden');
        copia.removeAttribute('style');
        if (getComputedStyle(mas.closest('.mr-res__tarjeta')).color === 'rgb(255, 255, 255)') copia.classList.add('mr-res__tarjeta--oscura');
        contenido.textContent = '';
        contenido.appendChild(copia);
        sec.setAttribute('data-ventana', '');
        ventana.showModal();
      });
      todos('[data-mr-res-cerrar]', ventana).forEach(function (b) {
        b.addEventListener('click', function () {
          ventana.close();
        });
      });
      ventana.addEventListener('click', function (ev) {
        if (ev.target === ventana) ventana.close();
      });
      ventana.addEventListener('close', function () {
        sec.removeAttribute('data-ventana');
      });
    });
  }

  /* Vídeo de aplicación: se reproduce solo cuando está a la vista */
  function initVideos() {
    var videos = todos('[data-mr-video-caja] video');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      },
      { threshold: 0.25 }
    );
    videos.forEach(function (v) {
      if (v.dataset.mrListo) return;
      v.dataset.mrListo = '1';
      v.muted = true;
      obs.observe(v);
    });
  }

  /* Enlaces que llevan al botón de compra */
  function initIrComprar() {
    todos('[data-mr-ir-comprar]').forEach(function (el) {
      if (el.dataset.mrListo) return;
      el.dataset.mrListo = '1';
      el.addEventListener('click', function (ev) {
        var destino = document.querySelector('[data-mr-producto]');
        if (!destino) return;
        ev.preventDefault();
        destino.scrollIntoView({ behavior: sinMovimiento ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* Menú del móvil: al tocar un enlace que lleva a una parte de esta misma página, el menú se cierra */
  function initMenuAnclas() {
    var cajon = document.querySelector('header-drawer');
    if (!cajon || cajon.dataset.mrListo) return;
    cajon.dataset.mrListo = '1';
    cajon.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[href*="#"]');
      if (!a) return;
      var url;
      try {
        url = new URL(a.href, window.location.href);
      } catch (e) {
        return;
      }
      if (url.pathname !== window.location.pathname || !url.hash) return;
      var destino = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!destino) return;
      ev.preventDefault();
      var detalles = cajon.querySelector('details');
      if (detalles) {
        detalles.removeAttribute('open');
        detalles.classList.remove('menu-opening');
      }
      var resumen = cajon.querySelector('summary');
      if (resumen) resumen.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop');
      window.history.replaceState(null, '', url.hash);
      window.setTimeout(function () {
        destino.scrollIntoView({ behavior: sinMovimiento ? 'auto' : 'smooth', block: 'start' });
      }, 60);
    });
  }

  function init() {
    initReveal();
    todos('[data-mr-carril]').forEach(initCarril);
    initLupa();
    initVariantes();
    initBarra();
    initOpinion();
    initResenas();
    initVideos();
    initIrComprar();
    initMenuAnclas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* En el editor de Shopify las secciones se recargan sin recargar la página */
  document.addEventListener('shopify:section:load', init);
})();
